import React from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  MenuProps,
} from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';

import {
  AvailablePieceJointeDto,
  ComputedResponseDtoListAvailableFilesEnum,
} from 'lib_api/lib/api/gen';

import { availableFilesMapping } from 'utils/enumData';

import PieceJointeItem from './PieceJointeItem';

interface AvailableFilesDropdownProps {
  files: Set<ComputedResponseDtoListAvailableFilesEnum>;
  piecesJointes: AvailablePieceJointeDto[];
  downloadPieceJointe: (type: string) => void;
  deletePieceJointe?: (pieceJointe: AvailablePieceJointeDto) => void;
  downloadDocument: (file: ComputedResponseDtoListAvailableFilesEnum) => void;
  isWaiting: boolean;
}

const AvailableFilesDropdown = ({
  files,
  piecesJointes,
  downloadPieceJointe,
  downloadDocument,
  deletePieceJointe,
  isWaiting,
}: AvailableFilesDropdownProps): React.ReactElement => {
  function generateItemsForFiles(): ItemType[] {
    return [...files].map((file: ComputedResponseDtoListAvailableFilesEnum) => {
      return {
        key: file,
        label: isWaiting
          ? 'Veuillez patienter...'
          : availableFilesMapping[file],
        disabled: isWaiting,
        onClick: () => downloadDocument(file),
      };
    });
  }

  function buildFilesMenuGroup(): ItemType | null {
    if (files.size !== 0) {
      return {
        key: 'files',
        type: 'group',
        label: 'Documents générés dans le SI',
        children: generateItemsForFiles(),
      };
    }
    return null;
  }

  function generateItemsForPiecesJointes(): ItemType[] {
    return piecesJointes.map((pieceJointe: AvailablePieceJointeDto) => {
      return {
        key: pieceJointe.identifiant,
        disabled: isWaiting,
        icon: (
          <PieceJointeItem
            text={isWaiting ? 'Veuillez patienter...' : pieceJointe.libelle}
            onDeleted={() => deletePieceJointe?.(pieceJointe)}
          />
        ),
        onClick: () => downloadPieceJointe(pieceJointe.identifiant),
      };
    });
  }

  function buildPiecesJointesMenuGroup(): ItemType | null {
    if (piecesJointes.length !== 0) {
      return {
        key: 'pieces_jointes',
        type: 'group',
        label: 'Documents importés',
        children: generateItemsForPiecesJointes(),
      };
    }
    return null;
  }

  const items: MenuProps['items'] = [
    buildFilesMenuGroup(),
    buildPiecesJointesMenuGroup(),
  ];

  return (
    <AntdDropdown menu={{ items }}>
      <AntdButton type="primary" shape="round" className="ActionsButton">
        Documents disponibles <DownOutlined />
      </AntdButton>
    </AntdDropdown>
  );
};

export default AvailableFilesDropdown;
